export default "/images/6f539853fa3306a9ad2cc8da8ed3f1fa.avif";